import {createSelector} from "reselect";
import {State} from "../../../reducers";

const adminExportState = (state: State) => state.adminExport;

export const currentAdminExportAuthorStatus = createSelector(adminExportState, state => state.authorsStatus);
export const currentAdminExportReferentialStatus = createSelector(adminExportState, state => state.referencesStatus);
export const currentAdminExportPublishedElementStatus = createSelector(adminExportState, state => state.publishedStatus);
